import React, { useState } from 'react';
import { Phone, Mail, MapPin, Calendar, Users, Clock } from 'lucide-react';
import HeroSection from '../components/HeroSection';
import EventInfo from '../components/EventInfo';
import ServicePresentation from '../components/ServicePresentation';
import MenuSection from '../components/MenuSection';
import BeverageSection from '../components/BeverageSection';
import ServicesSection from '../components/ServicesSection';
import PriceCalculator from '../components/PriceCalculator';
import Gallery from '../components/Gallery';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FatraOfferPage from './FatraOfferPage';
import DakoOfferPage from './DakoOfferPage';
import SilentCzechOfferPage from './SilentCzechOfferPage';
import GreinerOfferPage from './GreinerOfferPage';
import GreinerLiptalOfferPage from './GreinerLiptalOfferPage';
import PromensOfferPage from './PromensOfferPage';
import BestDriveOfferPage from './BestDriveOfferPage';
import BestDriveFleetPage from './BestDriveFleetPage';
import SilentCzech30Page from './SilentCzech30Page';
import PSPlastyPage from './PSPlastyPage';
import ClimaxOfferPage from './ClimaxOfferPage';
import BarumOfferPage from './BarumOfferPage';
import GourmetCrewOfferPage from './GourmetCrewOfferPage';
import { useOffer } from '../context/OfferContext';

const HomePage = () => {
  const { offer, loading, error } = useOffer();

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-gray-600 text-xl">Načítání nabídky...</div>
      </div>
    );
  }

  // Show error state
  if (error || !offer) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-red-600 text-xl">Nabídka nenalezena</div>
      </div>
    );
  }

  // Route to different offer pages based on slug or eventType
  if (offer.slug === 'bestdrive') {
    return <BestDriveOfferPage />;
  }
  
  if (offer.slug === 'bestdrive-fleet') {
    return <BestDriveFleetPage />;
  }
  
  if (offer.slug === 'silent-czech-30') {
    return <SilentCzech30Page />;
  }
  
  if (offer.slug === 'ps-plasty') {
    return <PSPlastyPage />;
  }
  
  if (offer.slug === 'climax') {
    return <ClimaxOfferPage />;
  }
  
  if (offer.slug === 'barum') {
    return <BarumOfferPage />;
  }
  
  if (offer.slug === 'gourmet-crew' || offer.slug === 'gourmet-crew-otrokovice') {
    return <GourmetCrewOfferPage />;
  }
  
  if (offer.slug === 'greiner' || offer.slug === 'greiner-assistec') {
    return <GreinerOfferPage />;
  }
  
  if (offer.slug === 'greiner-liptal') {
    return <GreinerLiptalOfferPage />;
  }
  
  if (offer.slug === 'promens') {
    return <PromensOfferPage />;
  }
  
  if (offer.slug === 'silent-czech') {
    return <SilentCzechOfferPage />;
  }
  
  if (offer.eventType === 'letni_kino') {
    return <FatraOfferPage />;
  }
  
  if (offer.eventType === 'vyroci' || offer.slug === 'dako') {
    return <DakoOfferPage />;
  }

  // Default: Wanzl offer page
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Hero Section */}
      <HeroSection />
      
      {/* Event Info */}
      <EventInfo />
      
      {/* Service Presentation - NEW */}
      <ServicePresentation />
      
      {/* Menu Section */}
      <MenuSection />
      
      {/* Beverage Section */}
      <BeverageSection />
      
      {/* Services & Overhead */}
      <ServicesSection />
      
      {/* Price Calculator */}
      <PriceCalculator />
      
      {/* Gallery */}
      <Gallery />
      
      {/* Contact */}
      <ContactSection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
